import { render } from "./GestaoDeReunioes.vue?vue&type=template&id=b6b3b974"
import script from "./GestaoDeReunioes.vue?vue&type=script&lang=js"
export * from "./GestaoDeReunioes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__